(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('companyConsultants', CompanyConsultants)

    /** @ngInject */
    function CompanyConsultants($rootScope, $q, LoadingHelper, CompanyService, ConsultantTypeService, PersonService, CompanyConsultantService, UtilHelper, sweetAlert, PATHS) {
        function CompanyConsultantsController($scope) {
            const vm = this;

            let removeWatchShow = $scope.$watch('vm.show', newValue => {
                if (newValue && !vm.companyConsultants.length)
                    getCompanyConsultants();
            })

            $scope.$on('$destroy', () => {
                removeWatchShow();
            })

            vm.getConsultants = () => {
                return PersonService
                    .getConsultants()
                    .then(success => {
                        vm.consultants = success;
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.consultant-container');
                    })
            }

            vm.getConsultantTypes = () => {
                return ConsultantTypeService
                    .getAll()
                    .then(success => {
                        vm.consultantTypes = success.Registers;
                    }, error => {
                        UtilHelper.errorCallback(error);
                    })
            }

            vm.openModal = (companyConsultant = null) => {
                let modalAction = 'ADICIONAR';

                vm.companyConsultant = {};

                if (companyConsultant) {
                    vm.companyConsultant = angular.copy(companyConsultant);
                    vm.companyConsultant.RegistrationDateFormatted = companyConsultant.RegistrationDate ? moment(companyConsultant.RegistrationDate).format('DD/MM/YYYY HH:mm') : '';

                    vm.selectedConsultant = vm.consultants.find(x => x.Id == companyConsultant.PersonId);
                    vm.selectedConsultantType = vm.consultantTypes.find(x => x.Id == companyConsultant.ConsultantTypeId);

                    modalAction = 'EDITAR';
                }

                vm.modalAction = modalAction;

                $('#consultant-type').appendTo('body').modal('show');
            }

            vm.closeModal = () => {
                vm.companyConsultant = {};

                vm.consultantTypeForm.reset();
                $rootScope.removeMessage('.consultant');
                $rootScope.removeMessage('.consultantType');

                $('#consultant-type').modal('hide');
            }

            vm.save = () => {
                if (!vm.selectedConsultant) {
                    UtilHelper.setErrorMessageForm('.consultant');
                    return;
                }

                if (!vm.selectedConsultantType) {
                    UtilHelper.setErrorMessageForm('.consultantType');
                    return;
                }

                LoadingHelper.startLoading('.modal-loader');

                vm.companyConsultant.CompanyId = vm.companyId;
                vm.companyConsultant.PersonId = vm.selectedConsultant.Id;
                vm.companyConsultant.ConsultantTypeId = vm.selectedConsultantType.Id;

                CompanyConsultantService
                    .post(vm.companyConsultant)
                    .then(success => successCallback(success, !vm.companyConsultant.Id), errorCallback);
            }

            vm.delete = companyConsultantId => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Não é possível desfazer essa ação!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        LoadingHelper.startLoading('.loading-holder');

                        CompanyConsultantService
                            .deleteData(companyConsultantId)
                            .then(() => {
                                getCompanyConsultants();
                                LoadingHelper.stopLoading('.loading-holder');
                                UtilHelper.successCallback('delete');
                            }, error => {
                                UtilHelper.errorCallback(error);
                                LoadingHelper.stopLoading('.loading-holder');
                            })
                    }
                })
            }

            init();

            function getCompanyConsultants() {
                vm.isLoading = true;

                CompanyService
                    .getConsultants(vm.companyId, true)
                    .then(success => {
                        vm.companyConsultants = success;
                        vm.isLoading = false;
                    }, error => {
                        vm.personAssociationHistory = [];
                        vm.isLoading = false;
                        UtilHelper.errorCallback(error);
                    });
            }

            function successCallback(success, isPost) {
                vm.closeModal();

                UtilHelper.successCallback(isPost ? 'create' : 'update');
                LoadingHelper.stopLoading('.modal-loader');
            }

            function errorCallback(error) {
                LoadingHelper.stopLoading('.plus-holder');
                UtilHelper.errorCallback(error);
            }

            function init() {
                vm.companyConsultants = [];
                vm.consultants = [];
                vm.consultantTypes = [];
            }
        }

        function link(scope, element, attrs, ctrl) {
            if (ctrl.canUserEdit) {
                LoadingHelper.startLoading('.consultant-container');

                $q.all([ctrl.getConsultants(), ctrl.getConsultantTypes()])
                    .then(() => {
                        LoadingHelper.stopLoading('.consultant-container');
                    });
            }
        }

        return {
            bindToController: true,
            controller: CompanyConsultantsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/company-consultants/company-consultants.html`,
            scope: {
                show: '=',
                companyId: '=',
                canUserEdit: '='
            }
        }
    }
}());